import { render, staticRenderFns } from "./throughTransportChannel.vue?vue&type=template&id=c730b124&scoped=true&"
import script from "./throughTransportChannel.vue?vue&type=script&lang=js&"
export * from "./throughTransportChannel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c730b124",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\sdk_manage_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c730b124')) {
      api.createRecord('c730b124', component.options)
    } else {
      api.reload('c730b124', component.options)
    }
    module.hot.accept("./throughTransportChannel.vue?vue&type=template&id=c730b124&scoped=true&", function () {
      api.rerender('c730b124', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/throughTransport/throughTransportChannel.vue"
export default component.exports